import React, { FC } from 'react';
import type { Diagram as DiagramFields } from '@/generated/graphql';

type DiagramProps = {
    fields: DiagramFields;
};

const Diagram: FC<DiagramProps> = ({ fields }) => {
    return (
        <section>
            <p>
                {fields.id} Diagram {fields.adminTitle}
            </p>
        </section>
    );
};

export default Diagram;
